import { useQuery } from "@tanstack/react-query";
import { parseUIConfig, type UIConfigResponse } from "@k8s-dashboard/contracts";
import { apiGet } from "./client";

/**
 * UI 부트스트랩 설정 (ADR 0025 · Issue #13)
 * --------------------------------------------------------------------------
 * 인증된 요청 **한 번**입니다. 값이 배포 수명 동안 바뀌지 않으므로 stale로 만들지
 * 않고, 같은 키의 동시 호출은 react-query가 하나로 합칩니다. 화면 이동·언어 변경은
 * 이 요청을 다시 만들지 않습니다 — 언어는 브라우저가 고르고 서버는 목록만 줍니다.
 *
 * 응답은 엄격하게 검증합니다. 모르는 필드·모르는 언어가 통과하면 부트스트랩이
 * 흔들리고 화면 전체 문구가 흔들립니다.
 */
export const uiConfigQueryKey = ["ui-config"] as const;

export function useUIConfig() {
  return useQuery<UIConfigResponse>({
    queryKey: uiConfigQueryKey,
    queryFn: async ({ signal }) => parseUIConfig(await apiGet<unknown>("/api/v1/ui-config", {}, signal)),
    staleTime: Infinity,
    gcTime: Infinity,
    /* 실패해도 화면은 뜹니다 — 운영자 기본값은 우선순위의 마지막 단계이고,
       그 앞 단계(URL·저장값·브라우저 언어)가 이미 언어를 정할 수 있습니다. */
    retry: 1,
  });
}
